<template>
  <div>
    <van-tabbar
      fixed
      class="footNav"
      style="z-index: 300; box-shadow: 0rem 0rem 0.02rem 0.02rem #f2f2f2"
      active-color="#646566"
    >
      <van-tabbar-item :to="{ path: '/eindex', query: { gid: gid } }">
        <span :class="{ 'theme-col': router == 'Eindex' }">兑换专区</span>
        <template slot="icon" slot-scope="props">
          <van-icon class="iconfont icon-liwu1" :class="{ 'theme-col': router == 'Eindex' }" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item :to="{ path: '/eorderlist', query: { gid: gid, type: 0 } }">
        <span :class="{ 'theme-col': router == 'Eorderlist' }">我的订单</span>
        <template slot="icon" slot-scope="props">
          <van-icon
            class="iconfont icon-dingdan"
            :class="{ 'theme-col': router == 'Eorderlist' }"
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'footernav',
  data() {
    return {
      gid: this.$route.query.gid
    }
  },
  computed: {
    router: function () {
      console.log(this.$route.name)
      return this.$route.name
    }
  }
}
</script>

<style lang="less" scoped>
.footNav {
  padding: 0.03rem 0 0.03rem;
  .van-tabbar {
    height: auto;
  }
  .van-icon {
    font-size: 0.28rem;
  }
  .van-tabbar-item__text {
    span {
      font-size: 0.28rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footernav1.vue